import React, { FC } from 'react';
import { Typography, TypographyProps, styled } from '@material-ui/core';

const StyledTypography = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '1rem',
  flexGrow: 1,
});

const ChapterTitle: FC<TypographyProps> = (props) => <StyledTypography {...props} />;

export default ChapterTitle;
